// Map registry (audio side). Every src/maps/<id>/audio.ts exporting `AUDIO: MapAudioDef` is picked up automatically, like
// render.ts. A map without one falls back to the default map's soundscape. Pure data (no WebAudio objects at import time).
import type { MapAudioDef } from '../audio/mapAudioDef';
import { DEFAULT_MAP, mapById } from './registry';

const found = import.meta.glob<{ AUDIO: MapAudioDef }>('./*/audio.ts', { eager: true });
const BY_ID = new Map<string, MapAudioDef>();
for (const [path, m] of Object.entries(found)) {
  const folder = path.split('/')[1];
  if (!m.AUDIO || m.AUDIO.id !== folder) throw new Error(`map folder ${folder}: audio.ts must export AUDIO with id '${folder}'`);
  BY_ID.set(folder, m.AUDIO);
}

/** ids that have their own audio recipe */
export const MAP_AUDIO_IDS: readonly string[] = [...BY_ID.keys()].sort();

/** Audio recipe for a map id (unknown / missing → the default map's). */
export function mapAudio(id: string): MapAudioDef {
  return BY_ID.get(mapById(id).id) ?? BY_ID.get(DEFAULT_MAP)!;
}
